import {PlatformLocation} from '@angular/common';
import {Component, HostListener, OnDestroy} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {SidebarOptions} from '~core/models';
import {SidebarService} from '~core/components/sidebar/sidebar.service';
import {NavigationService, StorageService} from '~core/services';

/**
 * Initializes the base layout.
 */
@UntilDestroy()
@Component({
  selector: 'app-crm',
  templateUrl: './crm.component.html'
})
export class CrmComponent implements OnDestroy {
  public sidebarOptions: SidebarOptions;
  public screenWidth: any;
  public currentBaseHref: any;

  constructor(
    private browserLocation: PlatformLocation,
    public sidebarService: SidebarService,
    public navigationService: NavigationService,
    public router: Router,
    public route: ActivatedRoute,
    public storage: StorageService
  ) {
    this.onResize();
    this.currentBaseHref = this.browserLocation.getBaseHrefFromDOM();
    this.sidebarService.castIsOpened.pipe(untilDestroyed(this))
      .subscribe(sidebarOptions => this.sidebarOptions = sidebarOptions);
  }

  public ngOnDestroy(): void { }

  /**
   * Clicking the hamburger icon will toggle the sidebar by changing the value inside the service
   */
  public toggleSidebar(): void {
    this.sidebarService.toggleSidebar();
  }

  /**
   * Change screen width on resize.
   */
  @HostListener('window:resize', ['$event'])
  public onResize(event?: any): any {
    this.screenWidth = window.innerWidth;
  }
}
